import React, { useCallback, useMemo } from "react";

// REDUX
import {
  acceptOrderThunk,
  finishOrderThunk,
  readyToPickupOrderThunk,
  setShowOrderInfosModal,
} from "../../../store/actions/ordersSlice";
import { useDispatch, useSelector } from "react-redux";
import { setSelectOrderDriverModalOrder } from "../../../store/actions/driversSlice";
// APP COMPONENTS
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import OrdersRow from "./ordersRow";
import Typography from "@mui/material/Typography";
// ICONS
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import { grey } from "@mui/material/colors";
import CashierOrderRow from "./CashierOrderRow";

export default function OrdersList({
  header = "Pedidos",
  orders = [],
  setOrders,
  showButtonMore,
  loadOrders,
  type = "dashboard",
}) {
  const dispatch = useDispatch();

  const showOrderInfosModal = useSelector(
    (state) => state.orders.showOrderInfosModal
  );
  const showSelectOrderDriverModal = useSelector(
    (state) => state.drivers.showSelectOrderDriverModal
  );

  const handleOrderAction = useCallback(
    async (action, order) => {
      try {
        // Wait for dispatch to complete
        const result = await dispatch(action({ order }));

        console.log("RESULKT", result);

        if (result?.error) {
          console.error("Error during dispatch:", result.error);
          return;
        }

        // Only update status_number if the action is finishOrderThunk
        if (action === finishOrderThunk) {
          setOrders((prevOrders) =>
            prevOrders.map((o) =>
              o.order_id === order.order_id
                ? { ...o, status_number: 34 } // Update status_number
                : o
            )
          );
        }

        if (action === readyToPickupOrderThunk) {
          setOrders((prevOrders) =>
            prevOrders.map((o) =>
              o.order_id === order.order_id
                ? { ...o, status_number: 21 } // Update status_number
                : o
            )
          );
        }

        setTimeout(() => {
          loadOrders();
        }, 2000);
      } catch (e) {
        console.error("Exception during handleOrderAction:", e);
      }
    },
    [dispatch, setOrders]
  );

  const orderRows = useMemo(() => {
    const handleSelectDriver = (item) => {
      dispatch(
        setSelectOrderDriverModalOrder({
          show: !showSelectOrderDriverModal,
          order: item,
        })
      );
      loadOrders();
    };

    const handleOrderModal = (order) => {
      const { order_id } = order;
      dispatch(
        setShowOrderInfosModal({
          orderId: order_id,
          show: !showOrderInfosModal,
        })
      );
      loadOrders();
    };

    if (type === "cashier") {
      return orders.map((item, index) => (
        <CashierOrderRow
          key={index}
          item={item}
          dashboard
          minified
          showCenter={false}
          acceptOrder={() => handleOrderAction(acceptOrderThunk, item)}
          readyToPickupOrder={() =>
            handleOrderAction(readyToPickupOrderThunk, item)
          }
          finishOrder={() => handleOrderAction(finishOrderThunk, item)}
          handleOrderModal={() => handleOrderModal(item)}
          handleSelectDriver={(e) => handleSelectDriver(item, e)}
        />
      ));
    }

    return orders.map((item, index) => (
      <OrdersRow
        key={index}
        item={item}
        dashboard
        minified
        showCenter={false}
        acceptOrder={() => handleOrderAction(acceptOrderThunk, item)}
        readyToPickupOrder={() =>
          handleOrderAction(readyToPickupOrderThunk, item)
        }
        finishOrder={() => handleOrderAction(finishOrderThunk, item)}
        handleOrderModal={() => handleOrderModal(item)}
        handleSelectDriver={(e) => handleSelectDriver(item, e)}
      />
    ));
  }, [orders]);

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" align="center">
        {header}
      </Typography>
      <Divider sx={{ my: 1 }} />
      {orderRows}

      <Box
        alignItems="center"
        justifyContent="center"
        sx={{
          display: "flex",
        }}
      >
        <Button
          title="Carregar mais"
          size="large"
          disabled={!showButtonMore}
          fullWidth
          sx={{
            borderTop: `1px solid ${grey[200]}`,
            color: grey[800],
          }}
          startIcon={<ExpandCircleDownIcon fontSize="inherit" />}
          onClick={() => loadOrders(false)}
        >
          {orders.length > 0
            ? "Mostrar mais"
            : "Parece que não tem nenhum pedido"}
        </Button>
      </Box>
    </Box>
  );
}
